// export const getDefaultFiltersForRoute = (path) => {
//     const now = new Date();
//     let start, end;

//     if (path === '/center-daily-report') {
//         end = new Date();
//         start = new Date();
//         start.setDate(end.getDate() - 1);
//     } else if (path === '/doctor_revenue') {
//         start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
//         end = new Date(now.getFullYear(), now.getMonth(), 0);
//     } else {
//         return {}; // No default filters for other routes
//     }

//     const formatDate = (d) => {
//         const year = d.getFullYear();
//         const month = String(d.getMonth() + 1).padStart(2, '0');
//         const day = String(d.getDate()).padStart(2, '0');
//         return `${year}-${month}-${day}`;
//     };

//     return {
//         dateRange: `${formatDate(start)} - ${formatDate(end)}`
//     };
// };

export const getDefaultFiltersForRoute = (path) => {
    const now = new Date();
    const formatDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

    const configs = {
        '/center-daily-report': () => {
            const end = new Date();
            const start = new Date();
            start.setDate(end.getDate() - 1);
            return { dateRange: `${formatDate(start)} - ${formatDate(end)}` };
        },
        '/doctor_revenue': () => {
            const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const end = new Date(now.getFullYear(), now.getMonth(), 0);
            return {
                dateRange: `${formatDate(start)} - ${formatDate(end)}`,
                doctorName: { label: "Assistant Doctor's", id: 1 }
            };
        },
        '/center-report': () => {
            const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const end = new Date(now.getFullYear(), now.getMonth(), 0);
            return {
                dateRange: `${formatDate(start)} - ${formatDate(end)}`,
                centerName: { label: "SAAOL Delhi Jonapur", id: 1 }
            };
        }
    };

    return configs[path]?.() || {};
};

